<template>
  <section class="pic-faixas border rounded p-1 mb-1">
    <div class="pic-faixas-heading d-flex justify-content-between align-items-start mb-1">
      <div>
        <h5 class="mb-50">Desconto por quantidade</h5>
        <p class="mb-0 text-muted">Um produto, várias faixas. O desconto considera a quantidade desse produto no pedido.</p>
      </div>
      <button v-if="!disabled" type="button" class="btn btn-sm btn-outline-primary ml-1" @click="add">
        + Adicionar faixa
      </button>
    </div>
    <div class="table-responsive">
      <table class="table table-sm mb-0">
        <thead><tr><th>De (un.)</th><th>Até (un.)</th><th>Desconto (%)</th><th>Preço unitário</th><th><span class="sr-only">Ações</span></th></tr></thead>
        <tbody>
          <tr v-for="(row, index) in value" :key="index">
            <td data-label="De (un.)"><input :value="row.min" type="number" min="1" step="1" class="form-control" :disabled="disabled"
              :aria-label="`Faixa ${index + 1}: quantidade inicial`" @input="change(index, 'min', $event.target.value)"></td>
            <td data-label="Até (un.)"><input :value="row.max" type="number" :min="row.min || 1" step="1" class="form-control" :disabled="disabled"
              placeholder="Sem limite" :aria-label="`Faixa ${index + 1}: quantidade final, vazio significa sem limite`"
              @input="change(index, 'max', $event.target.value)"></td>
            <td data-label="Desconto (%)"><input :value="row.desconto" type="number" min="0" max="99.99" step="0.01" class="form-control" :disabled="disabled"
              :aria-label="`Faixa ${index + 1}: desconto percentual`" @input="change(index, 'desconto', $event.target.value)"></td>
            <td data-label="Preço unitário" class="text-nowrap">{{ preview(row) }}</td>
            <td class="faixa-actions"><button v-if="!disabled" type="button" class="btn btn-sm btn-outline-danger"
              :aria-label="`Remover faixa ${index + 1}`" @click="remove(index)">Remover</button></td>
          </tr>
        </tbody>
      </table>
    </div>
    <p v-if="error" class="text-danger mt-1 mb-0" role="alert">{{ error }}</p>
    <p v-else class="text-muted mt-1 mb-0">Deixe “Até” vazio na última faixa para “Sem limite”. Os limites são inclusivos. Preços antes dos impostos.</p>
  </section>
</template>

<script>
import { normalizarFaixas } from '@/services/Operacoes/picFaixas';

export default {
  props: {
    value: { type: Array, default: () => [] },
    base: { type: [String, Number], default: '' },
    disabled: { type: Boolean, default: false },
  },
  computed: {
    error() {
      if (!this.value.length) return 'Adicione pelo menos uma faixa.';
      try { normalizarFaixas(this.value); return ''; } catch (error) { return error.message; }
    },
  },
  methods: {
    change(index, field, value) {
      this.$emit('input', this.value.map((row, i) => (i === index ? { ...row, [field]: value } : { ...row })));
    },
    remove(index) { this.$emit('input', this.value.filter((_, i) => i !== index).map(row => ({ ...row }))); },
    add() {
      const rows = this.value.map(row => ({ ...row }));
      const last = rows[rows.length - 1];
      if (last && (last.max === null || last.max === '')) last.max = Number(last.min);
      rows.push({ min: last ? Number(last.max) + 1 : 1, max: null, desconto: 0 });
      this.$emit('input', rows);
    },
    preview(row) {
      if (!(Number(this.base) > 0) || row.desconto === '' || !(Number(row.desconto) >= 0 && Number(row.desconto) < 100)) return '—';
      return (Math.round(Number(this.base) * (1 - Number(row.desconto) / 100) * 100) / 100)
        .toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    },
  },
};
</script>

<style scoped>
.pic-faixas input { min-width: 95px; }
.pic-faixas th { white-space: nowrap; }
@media (max-width: 767px) {
  .pic-faixas-heading { flex-direction: column; gap: 12px; }
  .pic-faixas-heading > button { margin-left: 0 !important; white-space: nowrap; }
  .pic-faixas table, .pic-faixas tbody { display: block; width: 100%; }
  .pic-faixas thead { display: none; }
  .pic-faixas tr { display: grid; grid-template-columns: minmax(0, 1fr) minmax(0, 1fr); border-top: 1px solid #b8b8b8; padding: 8px 0; }
  .pic-faixas td { display: block; border: 0; padding: 6px; }
  .pic-faixas td[data-label]::before { content: attr(data-label); display: block; font-size: 12px; margin-bottom: 4px; }
  .pic-faixas input { min-width: 0; width: 100%; }
  .pic-faixas .faixa-actions { grid-column: 1 / -1; text-align: right; }
}
</style>